import React, { useState, useEffect } from "react";

import ArrowIcon from "../../../../icons/arrow-icon";
import DeptPaymentIcon from "../../../../icons/debt-payment-icon";
import DirectExpenseIcon from "../../../../icons/direct-expenses-icon";
import IndirectExpensesIcon from "../../../../icons/indirect-expenses-icon";
import SalaryBenefitsIcon from "../../../../icons/salary-benefits-icon";

import lbl from "../../../../data/Labels.json";
import db from "../../../../services/query";

const ExpensesTabs = ({ handleCurrentTab, currentTab }) => {
  const [tabs, setTabs] = useState([]);

  useEffect(async () => {
    const ac = new AbortController();

    await db.getAll("expenses/types").then(({ data }) => {
      setTabs(data.data);
    });

    return () => ac.abort();
  }, []);

  const renderIcon = (name) => {
    switch (name) {
      case "Teacher Salaries":
        return <SalaryBenefitsIcon />;
      case "Staff Salaries":
        return <SalaryBenefitsIcon />;
      case "Direct Expenses":
        return <DirectExpenseIcon />;
      case "Indirect Expenses":
        return <IndirectExpensesIcon />;
      case "Debt Payments":
        return <DeptPaymentIcon />;
      default:
        return null;
    }
  };

  return (
    <div className="site-tab-items">
      <button>
        <i>
          <ArrowIcon />
        </i>
        <span>{lbl.Expenses}</span>
      </button>
      <ul>
        {tabs.map((tab) => (
          <li
            key={tab.id}
            onClick={() => handleCurrentTab(tab, "expenses")}
            className={`${currentTab?.name_en === tab?.name_en && "active"}`}
          >
            <i>{renderIcon(tab.name_en)}</i>
            <span>{tab.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ExpensesTabs;
